import { css } from '@emotion/react';
import styled from '@emotion/styled';
import MEDIA_QUERY from '@zola/zola-ui/src/styles/emotion/mediaQueryV2';
import SPACING from '@zola/zola-ui/src/styles/emotion/spacing';

export const HeroContainer = styled.div`
  display: flex;
  text-align: start;
  margin-bottom: ${SPACING.S8};

  ${MEDIA_QUERY.DESKTOP} {
    align-items: center;
    justify-content: center;
    text-align: center;
    margin-bottom: ${SPACING.S16};
  }
`;

export const HeroContent = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  row-gap: ${SPACING.S16};

  ${MEDIA_QUERY.DESKTOP} {
    align-items: center;
    max-width: 680px;
  }
`;

export const Subheading = css`
  line-height: ${SPACING.MD};
`;
